var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-footer"}},[_c('footer-desktop'),_c('footer-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }